import type { ButtonHTMLAttributes, ReactNode } from "react";

interface FilterChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  active: boolean;
  children: ReactNode;
}

export function FilterChip({ active, className = "", children, ...props }: FilterChipProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={`rounded-full px-3 py-1.5 text-[10px] tracking-[0.2em] ring-1 transition ${
        active
          ? "bg-ink text-on-ink ring-ink"
          : "text-ink/70 ring-ink/15 hover:bg-ink hover:text-on-ink"
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
